<template>
  <div class="header-row">
    <div class="idxmain">
      <h1>
        <img src="../../assets/idx-logo1.png"/>
        <p>{{userInfo.userUserName}}</p>
      </h1>
      <div class="container">
        <baidu-map
          class="store-map"
          :center="location"
          :zoom="11"
          :scroll-wheel-zoom="true"
          @ready="onMapHandler"
          >
          <bm-city-list anchor="BMAP_ANCHOR_TOP_LEFT"></bm-city-list>
          <bm-scale anchor="BMAP_ANCHOR_BOTTOM_LEFT"></bm-scale>
          <bm-navigation anchor="BMAP_ANCHOR_BOTTOM_RIGHT" type="BMAP_NAVIGATION_CONTROL_ZOOM"></bm-navigation>
        </baidu-map>
        <div class="idx-left animated fadeInLeft">
          <div class="weather">
            <div class="icon-model">
              <div :class="`weather-icon ${weatherIcon}`"></div>
            </div>
            <span class="weather-text">{{weatherTxt}}</span>
            <span>{{weatherTemp}}℃</span>
          </div>
          <ul>
            <li>
              <p>{{currStore.userStoreName||'仓库'}}</p>
              <div class="empty-content" v-if="subList.length==0">暂无数据</div>
              <div class="idx-content" v-if="subList.length>0">
                <table>
                  <tr
                    v-for="(item, index) in subList"
                    :key="index"
                    :index="item.userSubId"
                    :class="item.userSubId==currSub.userSubId?'active':''"
                    @click="onClickSub(item.userSubId)"
                    >
                    <td :title="item.userSubName">{{item.userSubName}}</td>
                    <td>{{item.value1?(item.value1+'℃'):''}}</td>
                    <td>{{item.value2?(item.value2+userInfo.userHumUnit):''}}</td>
                  </tr>
                </table>
              </div>
            </li>
          </ul>
        </div>

        <div class="down animated fadeInUp">
          <div class="item">
            <div class="title">
              <p>{{currSub.userSubName}}-温度</p>
            </div>
            <div class="empty-content" v-if="currSubChartEmpty">暂无数据</div>
            <div class="temp-chart" :style="{display:currSubChartEmpty?'none':'block',zoom:1/zoom,transform:`scale(${zoom})`,'transform-origin':'0 0'}"></div>
          </div>
          <div class="item">
            <div class="title">
              <p>{{currSub.userSubName}}-{{userInfo.userHumName}}</p>
            </div>
            <div class="empty-content" v-if="currSubChartEmpty">暂无数据</div>
            <div class="hum-chart" :style="{display:currSubChartEmpty?'none':'block',zoom:1/zoom,transform:`scale(${zoom})`,'transform-origin':'0 0'}"></div>
          </div>
        </div>
        <div class="idx-right animated fadeInRight">
          <div class="time">
            <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADgAAAA4CAYAAACohjseAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAAMxSURBVGiB7VrLkqsgED1Y80ksktWQLxvny0JWuvCfuAtBBZVuHhozdU/V1CRRmz72A2ha4CDIzrTTF4Fv+0nZ/3q6ZvBy34e7mH+vBFFLkOyMAqAg8FMgRgMADH5rkS0mKDvTFpLax0i0LRGRTfBQYj50iUWTCZ5ILEQW0SSCbyQ3I9Ft2QQvQW6GHm7iwbmRRVD25ok5xbOVsFPA+BnzNGAzroOy00iOfNJlowRlZxQEnknDZma+ifToJYr73HATUQ5xgimWq5DSp3HHF8slGnXXXYJschWJrXTgxn1Eh02CCYIfRyyvAl14YbJDckWQKZCdxWqA7bIbJNcEadc8ldwSnLAJk07jCXAL5hgMfrOU60wre2PsX1pmtuC8WG8Xg4AgGXeZMSd78wxkq1ySMIiTDDhMBC1zFRGcteCNeIUK3zYHw11oyouWcmcLxq2nC6YClfncLkhdFlwaYLV0WiMz7g4FbUUFOAvS1tO19KoFhkcpIEwyW7ii9RxiulmjNayp4aLg5AXKgpd0zwB674LsTNvgQ603Yd5zbqJZ1Cy3Hr5u/DFBJ5nrQ+9eEfj+CwSjiMbgByQYSkf1dZYimxD4kb2JLjJKy/gN4mlW5QquBAWBZ2xRTuioPyMGY5meQEPMIypXcGWo3AfPsKA+WIbavWLwihMscA0HmyB0kZD4ojqmoxYAIHtj9u6gKsdcLEoUKuExDYPX3qKarAAaPMhpQnamrVHYfUMlTg93YbMoY191STB0czGoYzflFIeOBrmPtUab4isWh0C9WKwFqgjs9J2zaEIp7t3glDjdR88qlBXPOGyhwDg78Y4W/HmQ2uCmHoZWButgKODgEeRMB9kl9xqgs+aqhrReydBlCiV78zx7p8E6kN3Q/c8fgG6uRYe7aFkFJ2KvVgr7ojkhsXt2UqsJoXjn7Y2b1pOT14QwDUZNHcFgzvKZR23pzUZEmNAE01o6lnCNQNPgG41AymqR1QjEWcDzW7nyup2OQULrCntHP9zE4xKV7qOa8RwKXLYcGU1HJQ2x5xEt6Kb639LMxcKiQIlVxzivdi55yCbWmwb8qpf7XQPwzvaOauj7B1cmr23ovdikAAAAAElFTkSuQmCC"/>
            <span class="date">{{currDate}}</span>
            <span>{{currTime}}</span>
            <div class="togger" @click="handleNewOpen">
              <i class="el-icon">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024"><path fill="currentColor" d="m160 96.064 192 .192a32 32 0 0 1 0 64l-192-.192V352a32 32 0 0 1-64 0V96h64zm0 831.872V928H96V672a32 32 0 1 1 64 0v191.936l192-.192a32 32 0 1 1 0 64zM864 96.064V96h64v256a32 32 0 1 1-64 0V160.064l-192 .192a32 32 0 1 1 0-64l192-.192zm0 831.872-192-.192a32 32 0 0 1 0-64l192 .192V672a32 32 0 1 1 64 0v256h-64z"></path></svg>
              </i>
              <span>全屏</span>
            </div>
          </div>
          <ul>
            <li>
              <div class="school">
                <p>{{ weatherLabel }}</p>
                <ul>
                  <li>
                    <div class="school-icon">
                      <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAA8CAYAAAAgwDn8AAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAALuSURBVGiB7ZpNdusgDIUvtINk+HyynzoL8Jpqr8kLKG8/PckwmbzyBpgE/4ARyKaDfLMkDuYiCYRAgMitP9XATw0AAvgEtAIAjbcOAI7Nt6K2mYOgPHzv/3wBog4/pZXGW7eXkCgBt75qzWjHo4Hu2FzapF4RWBWQ0nkLRUSqawYF3PpTLfDzFd3jBQ7NhWWQfIMRbDzO58OErEAfoHl8Sd+jxqR5nQeMO5i2ln6jWlfUAv9GlvIKsP7Iw7wtY90URH3rq9Z+8goQ0B9pL1gn17puvAQskO8+zxeOB2PqBi4a6A7NRWjIswY633PWCu9cnQwTNxhuwA+Bqm59hdAMFbDAliwLWp6tpFpsYbBqIQF8FBJgVtkp7uzyJDwbFhGgIf4ufW/WjKeI0AptU4ydgjgeAXze+yo69ypigWNzaUNT5BpmtjLpRLEgTk+1tXL/W3QW0pBn4j+U9X1L0RgY3EDEZL3Gba7t9PtfEcSH5nq2GxqzQBkxzziRiryhufeV5u3k+sYmhYwY0MomXb6FaQ+SBbh7Vd/CtAfJAlyf3KP64OOVzJXmJaA0LwGlWRTgK0T9RmYCOOqhS6QXssKMBGzVeYOotxAxEhAqOPEwLgty8BBgGuarxvmYbtxzkYB1nbRDjBQ43yVNg1u7zhwuKwwuRHOd5YoCbU/AZQVBm3m0OjRX70acOotpyHPuaaakuM+0IjDFbG4olYb8QxRCKqG9G2sXIyK9aEUlWsDa6KfAcQokYwOY5qvLNf05+etO4Ww0v5ohYxvhTgG4kFuURPZcGKNdKDaHoeRUHINHioHQqTuQcjEkNtiDfUqpg07L3O4tk/g2Qqt6LO+AyW1oLxe1yFxFudaVR8WYuxq9Ble1+hEDey7/9JMZPw8BuQdvsbgHdBzMzMhxyckPT+C6zKZRE1z8BxbmFgpv54HAEVPOZb8pW95gXLn0ly9i6+uXkfdGT8Ndtfh7P8A+JzekuXh8t3O8GbF5zd7HTf8BzLZSdfccFCQAAAAASUVORK5CYII=" alt=""/>
                    </div>
                    <div class="school-text">
                      <p class="number"><span>{{weatherTemp}}</span>℃</p>
                      <p>温度</p>
                    </div>
                  </li>
                  <li>
                    <div class="school-icon">
                      <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAABCCAYAAAAR6FVNAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAALlSURBVGiB1VpLdoMwDBRuj5QNqybHaV/ukHKHvPY4patsuFJCF7bBAdmWbMvQ2fSVj0AaSVjjAGyMw+39J+d+VepFUnC4fXwCNEf9Nw1Nudfh4XA7HwEebvS7of365NrZkIH7ZXFg+T8JmzhgUwc/zkP1FEJSZwlWKm3AwCp1lmClUlUHdPTXqbO+jp5KlRkIpo4LMgvVHOAWKPX6KkVMKFwfogVdiYFo4SZD3AFq4XpwiaVSBQayox+8X9SBzOg7dvwsCDMgl/sWwg7kR9/AGwgxB3T6lLSHp5EgA4+jnO0Zm05kPIxv2FG2A4fbOWsELI0EBu4XIC22VM+3HcJLhz6FY8KdpGIsDO2159hOBdkB01XcyEc/8wCARo2PsfcFhMEA+lEKplKKyoADTx8AogO+IXw+F0QuC10oHaPzAHEtH1y3GydTlhUl5gHKegbv0Rb6JdQJYOzjtiaQ1IkgA8zIkR6oGb1f8JQce4Dml1M7MQdGqiEAgKH9Yo2odr2U03K9D9SqMXs1maRv5gCtgYxBhPJtKApPEcsPIqWwcqDAGFiVBYSBItGvxuCTA6WGcG2rDgsLBormfhUWJgdKRn+2Kc+Cw4BI56kjq0hE30KaBcPA/+n7SxgHZKJvIBocVVqAwpCSRlT1Q+03fWjqRy1hixUkjvqhhPOfDa76sUNpkad+KOacmgjaM1LUDwXQ/Ka+lgBCtYKeq5RCfmHKgtIysWsac4I1vHMRG/aZ+8hPc7dloJCGiT8wfkn6t2iKjBQLhaO/sunUgDox340Aik3+VpRbC5MDRlwqmUpBUXZGWJb0YEq5py40a5jZYMiMaSsBuwhdtVEdNbYQa9EBqFMddU6n3it2ylDfh4XYJ3T6vpqyot6DI4ux89zgFp3ybv3Q7aZ2P3Ua2mu/2Q9fLVIdsK10D6vRhM43N5rNGQDgbqSM/dB+Tw7sgQFb/BQmOvflAXbCgIW/6/G3njZHDbVkF/gDdTEwF/l55pEAAAAASUVORK5CYII=" alt=""/>
                    </div>
                    <div class="school-text">
                      <p class="number"><span>{{weatherRh}}</span>%RH</p>
                      <p>湿度</p>
                    </div>
                  </li>
                </ul>
              </div>
            </li>

            <li>
              <div class="device">
                <p>设备状态统计</p>
                <div class="online">
                  <div class="top-arrow device-arrow">
                    <img class="device-arrow-one" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAA2CAYAAADd0Vm+AAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAAGJSURBVFiF1ZhBjoQgEEU/Sp/AmMxi1h6BZO7EXWbjqTwCazcT4wla4yzsnmAEpIpyMbXr7qQe/EcroCBYpp86LGsHANC1G2zr1C3N36VrGUCw+auq8uZjE2suAsDzEW0OXbsigOmnDmprgj9uah5sywekcgcAPJ4OADSveTr3fYl+zADXwUXug23d+yMZkJO7/xUJkJu7X9kOKLn7lT8DQu5kADV3EoCTu19JB9zc/UrPgJl7FqAk90tAae5+nRxI5O7XeQYCuUcBUrkHAZK5+6X35rK5+7XPQDj3A8D0YyOd+wGQHD0z9yMgNnqhqqDr+ChTs8sFDLZ12FR4haitMf1UBNlXUSrrZe1KIBUADPZzTka1rJ3pR5arv3/yYFt3h4/Ds+gOH+enqbCPE0DaR/CNJukj+k6W8pHeVQj4SAIkfFzu7Ep9ZO1NS3zk766ZPrIBXB+kEw7HB/mMRvXBO2USfLAAFB/sk36uj+LrHPP98xXdmZRehgC49FEMuPLxP67UgpDXpvkXud8p9yKmQ4gAAAAASUVORK5CYII=" alt=""/>
                  </div>
                  <div class="online-list">
                    <ul>
                      <li>
                        <div class="online-item">
                          <p>网关状态</p>
                          <ul>
                            <li>
                              <strong>{{onlineRate.gwTotalCount}}</strong>
                              <p>总数</p>
                            </li>
                            <li>
                              <strong style="color:#34c76a;">{{onlineRate.gwOnlineCount}}</strong>
                              <p>在线</p>
                            </li>
                            <li>
                              <strong style="color:#ff2e2e;">{{onlineRate.gwOfflineCount}}</strong>
                              <p>离线</p>
                            </li>
                          </ul>
                        </div>
                        <div class="online-pie-model">
                          <div class="online-text">
                            <p style="color: #f8b312;">{{onlineRate.gwOnlineRate}}</p>
                            <span>%</span>
                          </div>
                          <div class="online-pie gw-pie">
                          </div>
                        </div>
                      </li>
                      <li>
                        <div class="online-item">
                          <p>智能设备状态</p>
                          <ul>
                            <li>
                              <strong>{{onlineRate.subTotalCount}}</strong>
                              <p>总数</p>
                            </li>
                            <li>
                              <strong style="color:#34c76a;">{{onlineRate.subOnlineCount}}</strong>
                              <p>在线</p>
                            </li>
                            <li>
                              <strong style="color:#ff2e2e;">{{onlineRate.subOfflineCount}}</strong>
                              <p>离线</p>
                            </li>
                          </ul>
                        </div>
                        <div class="online-pie-model">
                          <div class="online-text">
                            <p style="color: #f8b312;">{{onlineRate.subOnlineRate}}</p>
                            <span>%</span>
                          </div>
                          <div class="online-pie sub-pie">
                          </div>
                        </div>
                      </li>
                      <li>
                        <div class="online-item">
                          <p>温湿度报警</p>
                          <ul>
                            <li>
                              <strong style="color:#34c76a;">{{onlineRate.subOnlineCount}}</strong>
                              <p>在线</p>
                            </li>
                            <li>
                              <strong style="color:#ff2e2e;">{{onlineRate.subAlertCount}}</strong>
                              <p>报警</p>
                            </li>
                          </ul>
                        </div>
                        <div class="online-pie-model">
                          <div class="online-text">
                            <p style="color: #f8b312;">{{onlineRate.subAlertRate}}</p>
                            <span>%</span>
                          </div>
                          <div class="online-pie alert-pie">
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                  <div class="bottom-arrow device-arrow">
                    <img class="device-arrow-two" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAA2CAYAAADd0Vm+AAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAAGJSURBVFiF1ZhBjoQgEEU/Sp/AmMxi1h6BZO7EXWbjqTwCazcT4wla4yzsnmAEpIpyMbXr7qQe/EcroCBYpp86LGsHANC1G2zr1C3N36VrGUCw+auq8uZjE2suAsDzEW0OXbsigOmnDmprgj9uah5sywekcgcAPJ4OADSveTr3fYl+zADXwUXug23d+yMZkJO7/xUJkJu7X9kOKLn7lT8DQu5kADV3EoCTu19JB9zc/UrPgJl7FqAk90tAae5+nRxI5O7XeQYCuUcBUrkHAZK5+6X35rK5+7XPQDj3A8D0YyOd+wGQHD0z9yMgNnqhqqDr+ChTs8sFDLZ12FR4haitMf1UBNlXUSrrZe1KIBUADPZzTka1rJ3pR5arv3/yYFt3h4/Ds+gOH+enqbCPE0DaR/CNJukj+k6W8pHeVQj4SAIkfFzu7Ep9ZO1NS3zk766ZPrIBXB+kEw7HB/mMRvXBO2USfLAAFB/sk36uj+LrHPP98xXdmZRehgC49FEMuPLxP67UgpDXpvkXud8p9yKmQ4gAAAAASUVORK5CYII=" alt=""/>
                  </div>
                </div>
              </div>
            </li>

            <li>
              <div class="warning">
                <p>今日告警</p>
                <div class="empty-content" style="margin-top: 60px;" v-if="alertList.length==0">暂无数据</div>
                <div class="idx-content" v-if="alertList.length>0">
                  <table>
                    <tr
                      v-for="(item, index) in alertList"
                      :key="index"
                      :index="item.seq">
                      <td>{{item.userSubName}}</td>
                      <td>{{item.value}}</td>
                      <td>{{item.alertTime}}</td>
                    </tr>
                  </table>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import axios from 'axios'
import * as echarts from 'echarts'

export default {
  name: 'userplatIdxManager',
  data () {
    return {
      menuName: 'userplatIdxManager',
      currStore: {},
      currSub: {},
      currSubChartEmpty: true,
      storeList: [],
      subList: [],
      alertList: [],
      onlineRate: {},
      httpUri: {
        storeList: '/dev/index/storeList',
        subList: '/dev/index/subList',
        chartData: '/dev/index/chartData',
        onlineRate: '/dev/index/onlineRate',
        alertList: '/dev/index/alertList',
        weather: '/dev/index/weather'
      },
      weatherTxt: '晴',
      weatherLabel: '深圳市南山区天气',
      weatherTemp: 32,
      weatherRh: 50,
      weatherIcon: 'sunny',
      currDate: '2024-09-26',
      currTime: '15:27:19',
      refreshTimer: null,
      location: { lng: 113.943702, lat: 22.552963 },
      BMap: null,
      map: null,
      needAddPoint: false,
      zoom: 1
    }
  },
  watch: {
    currStore: {
      handler (curVal, oldVal) {
        if (curVal) {
          this.querySubList()
          this.queryWeather()
        }
      }
    },
    currSub: {
      handler (curVal, oldVal) {
        if (curVal) {
          this.chartData()
        }
      }
    },
    $route (to, from) {
      if (this.menuName != to.name) { // 切走不处理
        return
      }
      this.init()
      if (this.currSub && this.currSub.userSubId) {
        this.chartData(this.currSub.userSubId)
      }
    }
  },
  mounted () {
    this.$nextTick(() => {
      window.onresize = this.resize

      this.init()
    })
    this.refreshTimer = window.setInterval(this.onTime, 1000)

    if (this.$route.name == 'indexFull') {
      this.$confirm('是否需要全屏显示', '全屏提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'info'
      }).then(() => {
        this.fullScreen()
      }).catch(() => {
        console.log('cancel full screen')
      })
    }
  },
  methods: {
    init () {
      this.resize()
      this.queryStoreList()
      this.queryAlertList()
      this.queryOnlineRate()
    },
    resize () {
      // console.log('resize')
      let h = document.documentElement.clientWidth

      let subWidth = 0
      // let l = document.getElementsByTagName('body')[0]
      let l
      if (this.$route.name == 'indexFull') {
        l = document.getElementsByTagName('body')[0]
      } else {
        l = document.querySelector('.header-row')
        let menuWidth = document.querySelector('.el-menu').clientWidth
        subWidth = menuWidth + 18
      }
      let u = (h - subWidth) / 1920
      // let u = h / 1920
      // this.scale = u
      if (u < 0.6) {
        u = 0.6
      }
      l.style.cssText = 'transform:scale(' + u + ');'
      l.style.cssText = `zoom:${u};`
      this.zoom = u
    },
    onTime () {
      const currentDate = new Date()
      const year = currentDate.getFullYear()
      const month = String(currentDate.getMonth() + 1).padStart(2, '0')
      const day = String(currentDate.getDate()).padStart(2, '0')
      const hours = String(currentDate.getHours()).padStart(2, '0')
      const minutes = String(currentDate.getMinutes()).padStart(2, '0')
      const seconds = String(currentDate.getSeconds()).padStart(2, '0')

      this.currDate = `${year}-${month}-${day}`
      this.currTime = `${hours}:${minutes}:${seconds}`
    },
    onClickSub (userSubId) {
      let subDev = this.subList.find(item => item.userSubId == userSubId)
      this.currSub = subDev || {}
    },
    queryStoreList () {
      axios({
        url: this.baseUrl + this.httpUri.storeList,
        method: 'post',
        data: {}
      }).then((res) => {
        // console.log(res, 'res')
        if (res.data.code === '0000') {
          this.storeList = res.data.data
          // console.log('this.storeList', this.storeList)
          if (this.storeList && this.storeList.length > 0) {
            if (!this.currStore || !this.currStore.userStoreId) {
              // this.currStore = this.storeList.find(item => item.userStoreId === 2)
              this.currStore = this.storeList[0]
            }
            if (this.BMap) {
              this.addPoints()
            } else {
              this.needAddPoint = true
            }
          }
        }
      }).catch((err) => {
        console.log(err, 'subList')
      })
    },
    querySubList () {
      axios({
        url: this.baseUrl + this.httpUri.subList,
        method: 'post',
        data: {
          userStoreId: this.currStore.userStoreId
        }
      }).then((res) => {
        // console.log(res, 'res')
        if (res.data.code === '0000') {
          this.subList = res.data.data
          if (this.subList && this.subList.length > 0) {
            this.currSub = this.subList[0] || {}
          }
        }
      }).catch((err) => {
        console.log(err, 'subList')
      })
    },
    chartData () {
      if (!this.currSub.userSubId) {
        return
      }
      axios({
        url: this.baseUrl + this.httpUri.chartData,
        method: 'post',
        data: { subId: this.currSub.userSubId }
      }).then((res) => {
        // console.log(res, 'res')
        if (res.data.code === '0000') {
          let data = res.data.data
          // console.log('data && data.dateList', data && data.dateList)
          if (data && data.dateList) {
            this.currSubChartEmpty = false
            this.$nextTick(() => {
              this.chartDataShow('.temp-chart', data.dateList, data.tempList, '温度', data.tempMax, data.tempMin, data.tempAlertMax, data.tempAlertMin)
              this.chartDataShow('.hum-chart', data.dateList, data.humList, this.userInfo.userHumName, data.humMax, data.humMin, data.humAlertMax, data.humAlertMin)
            })
          } else {
            this.currSubChartEmpty = true
            // console.log('this.currSubChartEmpty', this.currSubChartEmpty)
          }
        }
      }).catch((err) => {
        console.log(err, 'chartData')
      })
    },
    queryOnlineRate () {
      axios({
        url: this.baseUrl + this.httpUri.onlineRate,
        method: 'post',
        data: { }
      }).then((res) => {
        // console.log(res, 'res')
        if (res.data.code === '0000') {
          this.onlineRate = res.data.data
          this.pieShow('.gw-pie', this.onlineRate.gwOnlineRate)
          this.pieShow('.sub-pie', this.onlineRate.subOnlineRate)
          this.pieShow('.alert-pie', this.onlineRate.subAlertRate)
        }
      }).catch((err) => {
        console.log(err, 'queryOnlineRate')
      })
    },
    queryAlertList () {
      axios({
        url: this.baseUrl + this.httpUri.alertList,
        method: 'post',
        data: { }
      }).then((res) => {
        // console.log(res, 'res')
        if (res.data.code === '0000') {
          this.alertList = res.data.data
        }
      }).catch((err) => {
        console.log(err, 'queryAlertList')
      })
    },
    queryWeather () {
      axios({
        url: this.baseUrl + this.httpUri.weather,
        method: 'post',
        data: {
          userStoreId: this.currStore.userStoreId
        }
      }).then((res) => {
        // console.log(res, 'res')
        if (res.data.code === '0000' && res.data.data) {
          this.weatherTxt = res.data.data.text
          this.weatherTemp = res.data.data.temp
          this.weatherRh = res.data.data.rh
          this.weatherIcon = res.data.data.icon
          this.weatherLabel = res.data.data.label
        }
      }).catch((err) => {
        console.log(err, 'queryWeather')
      })
    },
    chartDataShow (className, xDataArr, yDataArr, showName, max, min, alertMax, alertMin) {
      var tempCharts = echarts.init(document.querySelector(className))
      var tempOption = {
        grid: {
          left: '0',
          right: '0',
          bottom: '0',
          top: '5%',
          containLabel: true
        },
        tooltip: {
          trigger: 'axis'
        },
        xAxis: {
          data: xDataArr,
          axisLabel: {
            color: '#fff'
          },
          axisLine: {
            lineStyle: {
              color: '#fff'
            }
          }
        },
        yAxis: {
          type: 'value',
          scale: true,
          axisLabel: {
            color: '#fff'
          },
          axisLine: {
            lineStyle: {
              color: '#fff'
            },
            show: true,
            onZero: false
          },
          axisTick: {
            show: true
          },
          min,
          max,
          splitLine: {
            show: false
          }
        },
        series: [
          {
            name: showName,
            type: 'line',
            smooth: true,
            itemStyle: {
              color: '#ff2a00'
            },
            data: yDataArr,
            markLine: {
              data: [{
                name: '报警最大值',
                yAxis: alertMax,
                lineStyle: {
                  color: 'yellow'
                }
              }, {
                name: '报警最小值',
                yAxis: alertMin,
                lineStyle: {
                  color: 'yellow'
                }
              }]
            }
          }
        ]
      }
      tempCharts.setOption(tempOption)
    },
    pieShow (className, value1) {
      // value1 = 80
      let value2 = 100 - value1
      var gwCharts = echarts.init(document.querySelector(className))
      var gwOption = {
        color: ['#f8b312', 'rgba(255,255,255,0.3)'],
        series: [
          {
            type: 'pie',
            radius: ['50%', '70%'],
            avoidLabelOverlap: false,
            itemStyle: {
              borderRadius: 20,
              borderWidth: 0
              // color: '#34c76a'
            },
            labelLine: {
              show: false
            },
            silent: true,
            data: [
              { value: value1 },
              { value: value2 }
            ]
          }
        ]
      }
      gwCharts.setOption(gwOption)
    },
    onMapHandler ({ BMap, map }) {
      this.BMap = BMap
      this.map = map
      if (this.needAddPoint) {
        this.addPoints()
      }
    },
    addPoints () {
      this.map.clearOverlays()
      var txtMenuItem = []
      this.storeList.forEach(item => {
        if (item.longitude && item.latitude) {
          this.addPoint(item)
          if (txtMenuItem.length < 20) {
            txtMenuItem.push({
              text: item.userStoreName,
              callback: () => {
                this.currStore = item
                setTimeout(() => {
                  this.map.panTo(new this.BMap.Point(item.longitude, item.latitude))
                }, 100)
              }
            })
          }
        }
      })
      if (this.currStore && this.currStore.longitude && this.currStore.latitude) {
        setTimeout(() => {
          this.map.panTo(new this.BMap.Point(this.currStore.longitude, this.currStore.latitude))
        }, 100)
      }
      if (txtMenuItem.length > 0) {
        var menu = new this.BMap.ContextMenu()
        for (var i = 0; i < txtMenuItem.length; i++) {
          const menuItem = new this.BMap.MenuItem(txtMenuItem[i].text, txtMenuItem[i].callback)
          menu.addItem(menuItem)
        }
        this.map.addContextMenu(menu)
      }
    },
    addPoint (store) {
      let content = store.userStoreName
      let longitude = store.longitude
      let latitude = store.latitude
      var point = new this.BMap.Point(longitude, latitude)
      var marker = new this.BMap.Marker(point)
      this.map.addOverlay(marker)

      var label = new this.BMap.Label(content, { // 创建文本标注
        position: point,
        offset: new this.BMap.Size(0, 0)
      })
      this.map.addOverlay(label)
      label.setStyle({ // 设置label的样式
        color: '#000',
        fontSize: '14px',
        border: '1px solid #1E90FF'
      })

      // var opts = {
      //   width: 250, // 信息窗口宽度
      //   height: 50 // 信息窗口高度
      // }
      // var infoWindow = new this.BMap.InfoWindow(txt, opts)
      marker.onclick = () => {
        // this.map.openInfoWindow(infoWindow, point)
        this.currStore = store
        // console.log('this.currStore', this.currStore)
      }
    },
    handleNewOpen () {
      if (this.$route.name == 'indexFull') {
        this.fullScreen()
        return
      }
      const { href } = this.$router.resolve({
        path: '/indexFull'
      })
      window.open(href, '_blank')
    },
    fullScreen () {
      const element = document.documentElement
      if (element.requestFullscreen) {
        element.requestFullscreen()
      } else if (element.mozRequestFullScreen) {
        element.mozRequestFullScreen()
      } else if (element.webkitRequestFullscreen) {
        element.webkitRequestFullscreen()
      } else if (element.msRequestFullscreen) {
        element.msRequestFullscreen()
      }
    }
  }
}
</script>

<style scoped>
@import "../../assets/index.css";
.temp-chart , .hum-chart , .online-pie {
  z-index: 1001;
}
.store-map {
  width: 1548px;
  height: 612px;
  position: absolute;
  top: 68px;
  left: 0;
}
</style>
